export const redirect = [
  {
    // Дубль в другом регистре: /Company → /company
    from: '^/Company$',
    to: '/company',
  },
  {
    // /Company/ (со слэшем) → сразу /company
    from: '^/Company/$',
    to: '/company',
  },
  {
    // eslint-disable-next-line
    from: '(?!^\/$|^\/[?].*$)(.*\/[?](.*)$|.*\/$)',
    to: (from : any, req : any) => {
      const base = req._parsedUrl.pathname.replace(/\/$/, '');
      const search = req._parsedUrl.search;
      return base + (search != null ? search : '');
    }
  }
];



